export const WecAiSchedulersFeatureName = 'WecAiSchedulers'
export const CourierExchangeManualAcceptFeatureName = 'CourierExchangeManualAccept'